export default __webpack_public_path__ + "static/media/point-circle-fill.0d258f8e.svg";